import React from "react";
import { FiPlus } from "react-icons/fi";

const CustomRecordingHistory = ({ data = [], handleSelectItem }) => {
  //console.log("datasdwe", data);
  return (
    <>
      <div className="row">
        {data.length > 0 ? (
          data.map((recording, index) => (
            <div
              className="col-md-4 mb-4"
              key={recording.id || index}
              onClick={() => handleSelectItem(recording)}
            >
              <div className="historyCard">
                <h3>{recording.title || `Recording ${index + 1}`}</h3>
                <p>
                  {recording.transcript
                    ? recording.transcript?.substring(0, 40) + "...."
                    : recording?.created_at || "No description provided."}
                </p>
              </div>
            </div>
          ))
        ) : (
          <div className="col-12 text-muted text-center py-4">
            No recordings available.
          </div>
        )}
      </div>
    </>
  );
};

export default CustomRecordingHistory;
